import React from 'react';
import { CountryCluster, Market } from '../../common/CountryMarketConfig';
import { Icon } from '../Icon';

export type CountryMarketDisplayProps = {
  countries?: CountryCluster[];
  markets?: Market[];
  customerName?: string;
};

const COUNTRY_MARKET_DISPLAY_CLASSES =
  'absolute top-0 right-0 flex items-start justify-between space-x-0.5 text-3xs tracking-[0.2em] font-medium uppercase pt-3 lg:pt-10 le pr-4 md:pr-9 text-gray-600 cursor-pointer';

export const CountryMarketDisplay: React.FC<CountryMarketDisplayProps> = ({
  countries,
  markets,
  customerName,
}) => {
  return (
    <div className={COUNTRY_MARKET_DISPLAY_CLASSES}>
      {countries && markets && (
        <>
          <div className="w-6 h-6 text-gray-600">
            <Icon name="Location" />
          </div>
          <div className="flex flex-col leading-0">
            <p data-testid="countries">
              {countries.map((country) => country).join(', ')}
            </p>

            <p data-testid="markets">
              {markets.map((market) => market).join(', ')}
            </p>
            {customerName && <p data-testid="customer-name">{customerName}</p>}
          </div>
        </>
      )}
    </div>
  );
};
